<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="3">
          <v-autocomplete
            outlined
            flat
            dense
            :items="employees"
            item-text="name"
            item-value="hrId"
            background-color="white"
            v-model="params.employeeId"
            label="Employee"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-menu
            v-model="menuStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.startDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                label="Start Date"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="params.startDate"
              @input="menuStartDate = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.endDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                label="End Date"
              ></v-text-field>
            </template>
            <v-date-picker v-model="params.endDate" @input="menuEndDate = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-select
            flat
            dense
            outlined
            background-color="white"
            v-model="params.status"
            :items="listStatus"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-btn color="primary" @click="search" class="mr-2">
            <v-icon>
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn v-if="$rbac.can('report.export')" color="success" @click="excel">
            <v-icon>
              mdi-file-excel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        flat
        outlined
        background-color="white"
        v-model="filter"
        placeholder="search"
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        dense
        hide-default-footer
        disable-pagination
        :search="filter"
        height="600"
      >
        <template v-slot:item.no="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.totalAmount="{ item }">
          {{ formatPrice(item.totalAmount) }}
        </template>
        <template v-slot:item.usedAmount="{ item }">
          {{ formatPrice(item.usedAmount) }}
        </template>
        <template v-slot:item.remainAmount="{ item }">
          {{ formatPrice(item.remainAmount) }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import fileDownload from "js-file-download";

export default {
  name: "report-settlement-outstanding",
  data() {
    return {
      params: {
        status: "All",
        startDate: moment()
          .startOf("month")
          .format("yyyy-MM-DD"),
        endDate: moment()
          .endOf("month")
          .format("yyyy-MM-DD"),
        employeeId: 0,
      },
      menuStartDate: false,
      menuEndDate: false,
      listStatus: ["All", "Outstanding", "Paid"],
      items: [],
      employees: [],
      filter: "",
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "No Reference",
          align: "center",
          sortable: false,
          value: "kasbonName",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 4,
          text: "Date",
          align: "center",
          sortable: false,
          value: "date",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "PIC",
          align: "center",
          sortable: false,
          value: "employeeName",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 6,
          text: "Penerima",
          align: "center",
          sortable: false,
          value: "ownerBank",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 7,
          text: "Remarks",
          align: "center",
          sortable: false,
          value: "remark",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 8,
          text: "Payment Type",
          align: "center",
          sortable: false,
          value: "paymentMethod",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 9,
          text: "Total Amount",
          align: "center",
          sortable: false,
          value: "totalAmount",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 9,
          text: "Used Amount",
          align: "center",
          sortable: false,
          value: "usedAmount",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 9,
          text: "Remain Amount",
          align: "center",
          sortable: false,
          value: "remainAmount",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 9,
          text: "Status",
          align: "center",
          sortable: false,
          value: "status",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    async getEmployees() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("external/getEmployees")
        .then(response => {
          this.employees = [{ name: "All", hrId: 0 }, ...response.data];
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/settlementExcel", this.params)
        .then(response => {
          fileDownload(response.data, `report-settlement-outstanding.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async search() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/settlement", this.params)
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  mounted() {
    this.getEmployees();
  },
};
</script>

<style></style>
